import devUrls from '@dxp-common-components-updated/config-global/api/apiUrls.dev'
import prodUrls from '@dxp-common-components-updated/config-global/api/apiUrls.prod'
import qaUrls from '@dxp-common-components-updated/config-global/api/apiUrls.qa'
import intUrls from '@dxp-common-components-updated/config-global/api/apiUrls.int'
import * as endpointsDefs from '@dxp-common-components-updated/config-global/api/apiEndpoints'
import appConfig from '../config'

type ApiUrls = Record<string, string>
type ApiEndpoints = Record<string, Record<string, string>>

// Deep clone endpoints so we can mutate them
const endpoints: ApiEndpoints = JSON.parse(JSON.stringify(endpointsDefs))
let urls: ApiUrls = {}

switch (appConfig.nodeEnv) {
case 'development': urls = devUrls; break
case 'qa': urls = qaUrls; break
case 'prod': urls = prodUrls; break
case 'int': urls = intUrls; break
default: urls = prodUrls; break
}

// Populate api urls in endpoints
for (const apiName in endpoints) {
  for (const endpoint in endpoints[apiName]) {
    if (apiName in urls) {
      endpoints[apiName][endpoint] = urls[apiName] + endpoints[apiName][endpoint]
    } else {
      throw Error('Missing api url declaration for ' + apiName)
    }
  }
}

/**
 * Validate and replace params in endpoint string
 */
const getEndpoint = function (endpoint: string, params: Record<string, string>): string {
  if (!endpoint) {
    throw Error('Missing endpoint definition')
  }

  const placeholders = endpoint.match(/(\{.*?\})/g)
  if (placeholders) {
    for (const param of placeholders) {
      const key = param.slice(1, -1)
      if (key in params) {
        endpoint = endpoint.replace(param, params[key])
      } else {
        throw Error('Missing endpoint url param value for ' + key)
      }
    }
  }
  return endpoint
}

/**
 * Turn an Object into Query String Parameters
 */
const getQueryString = function (params: Record<string, string | number | boolean>): string {
  const queryString = Object.keys(params)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
    .join('&')
  const queryMark = queryString.length === 0 ? '' : '?'

  return queryMark + queryString
}

export default {urls, endpoints, getEndpoint, getQueryString}
